import React, { useState, useEffect } from "react";
import { MySwal } from "../../../library/swal";
import axios from "../../../library/axios";
import Button from "react-bootstrap/Button";
import { getSlug, } from "../../../../src/config/routes/guards/slug";
import SelectInstruments from "react-select";
import { getApiErrorMessage } from "../../../helpers/apiErrorMessage";
import {
  MAX_UPLOAD_MB,
  DOCUMENT_MIME_TYPES,
  DOCUMENT_MIME_LABEL,
  validateUploadFile,
} from "../../../constants/upload";
import { notifyApiLoadError } from '../../../helpers/notifyApiError';

const AddDocumentSupportComp = (props) => {
  // console.log(props?.score?.id)
  const url = new URL(window.location.href);

  const [namaFile, setnamaFile] = useState("");
  const [deskripsi, setDeskripsi] = useState("");
  const [base64String, setBase64String] = useState("");
  const [mimeType, setMimeType] = useState("");
  const [originalName, setOriginalName] = useState("");

  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [scores, setScores] = useState([]);
  const [scoreIds, setScoreIds] = useState([]);

  const normalizeEpSearch = (str) => (str || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  const filterEpOption = (option, input) =>
    !input || normalizeEpSearch(option.label).includes(normalizeEpSearch(input));

  const fetchScores = async () => {
    try {
      const options = {
        url: `/skor/by-kegiatan/${props?.score?.idKegiatanAkreditasi}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      // return false
      setScores([]);
      data.map((d) =>
        setScores((scores) => [
          ...scores,
          {
            label: `${d?.variables_accreditation?.elements_accreditation?.Nomor}${d?.variables_accreditation?.Abjad}`,
            value: d.id,
          },
        ])
      );
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/document-support/create.fetchScores');
    }
  };

  useEffect(() => {
    fetchScores();
  }, []);

  const resetFileState = () => {
    setBase64String("");
    setMimeType("");
    setOriginalName("");
  };

  const handleImageChange = (e) => {
    const selectedFile = e.target.files && e.target.files[0];

    // User membatalkan dialog pilih file.
    if (!selectedFile) {
      resetFileState();
      setDisabled(false);
      return;
    }

    const invalid = validateUploadFile(selectedFile, {
      allowedMimeTypes: DOCUMENT_MIME_TYPES,
      allowedLabel: DOCUMENT_MIME_LABEL,
    });
    if (invalid) {
      MySwal.fire({ icon: "error", title: invalid.title, text: invalid.text });
      e.target.value = "";
      resetFileState();
      setDisabled(true);
      return;
    }

    setDisabled(false);
    setMimeType(selectedFile.type);
    setOriginalName(selectedFile.name);

    const reader = new FileReader();
    reader.onloadend = () => {
      setBase64String(reader.result);
    };
    reader.onerror = () => {
      resetFileState();
      setDisabled(true);
      MySwal.fire({
        icon: "error",
        title: "Gagal Membaca File",
        text: "File tidak dapat dibaca dari perangkat Anda. Silakan pilih ulang file-nya.",
      });
    };
    reader.readAsDataURL(selectedFile);
  };

  const handleSubmitDocumentSupport = () => {
    if (!base64String) {
      MySwal.fire({
        icon: "warning",
        title: "Dokumen Belum Dipilih",
        text: "Silakan pilih file dokumen (PDF atau Excel) terlebih dahulu sebelum menyimpan.",
      });
      return;
    }

    if (!props?.score?.id) {
      MySwal.fire({
        icon: "error",
        title: "Elemen Penilaian Tidak Dikenali",
        text: "Data elemen penilaian tidak terbaca. Silakan tutup form ini, muat ulang halaman, lalu coba lagi.",
      });
      return;
    }

    setLoading(true);
    setDisabled(true);

    const newScoreIds = [
      ...(props?.score?.id ? [{ idSkor: props.score.id }] : []),
      ...(Array.isArray(scoreIds) ? scoreIds : []).map(item => ({
        idSkor: item.value
      }))
    ];

    const requestBody = {
      baseUrl: url.origin,
      idSkor: props?.score?.id,
      dokumen: base64String,
      namaFile: namaFile || originalName,
      Deskripsi: deskripsi,
      mimeType: mimeType,
      scoreIds: newScoreIds,
    };

    axios({
      url: "/skor/upload-dokumen",
      method: "POST",
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        MySwal.fire({
          icon: "success",
          title: "Success",
          text: "Berhasil menambahkan dokumen pendukung!",
        });

        props.fetch();
        props.close();
      })
      .catch((err) => {
        console.error("[upload-dokumen] gagal:", err?.response?.status, err?.response?.data || err?.message);

        // Sesi habis / akses ditolak sudah ditangani (beserta pesannya) oleh
        // interceptor axios, jangan tampilkan alert ganda.
        if (err?.isHandledByInterceptor) return;

        MySwal.fire({
          icon: "error",
          title: "Dokumen Gagal Disimpan",
          text: getApiErrorMessage(
            err,
            "Dokumen gagal disimpan. Silakan coba lagi, dan hubungi administrator bila tetap gagal."
          ),
        });
      })
      .finally(() => {
        setLoading(false);
        setDisabled(false);
      });
  };

  // const handleMapingDocumentToEp = (idMasterDocument) =>{
  //   setLoading(true);
  //   setDisabled(true);

  //   const requestBody = {
  //     idMasterDocument: idMasterDocument,
  //     variablesAccreditation: [
  //       {
  //         idVariablesAccreditation: props?.IdVariable,
  //         idSkorsRs: props?.score?.id
  //       }
  //     ]
  //   };
  //   // console.log(requestBody)
  //   // return false
  //   axios({
  //     url: '/skor/mapping-master-dokumen-to-ep',
  //     method: 'POST',
  //     data: requestBody,
  //     headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
  //   })
  //     .then((res) => {
  //       // console.log(res)
  //       // return false
  //       if (res.status === 200) {
  //         MySwal.fire({
  //           icon: 'success',
  //           title: 'Success',
  //           text: 'Berhasil menambahkan dokumen pendukung!',
  //         });

  //         setLoading(false);
  //         setDisabled(false);

  //         props.fetch();
  //         props.close();
  //       }
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //       setDisabled(false);
  //       if (err !== '') {
  //         console.log(err?.response);
  //         MySwal.fire({
  //           icon: 'error',
  //           title: 'Oops, Error!',
  //           text: getApiErrorMessage(err),
  //         });
  //       }
  //     });
  // }

  // console.log(mimeType)

  return (
    <>
      <div className="mb-3 row">
        <label
          htmlFor="documentSupport"
          className="col-sm-12 col-form-label required"
        >
          Upload Dokumen
        </label>
        <div className="col-12">
          <input
            type="file"
            onChange={handleImageChange}
            className="form-control"
            id="documentSupport"
          />
        </div>
        <span>
          <i className="text-info required">
            Dokumen harus dalam bentuk PDF atau Excel, maksimal {MAX_UPLOAD_MB} MB
          </i>
        </span>
      </div>
      <div className="mb-3 row">
        <label htmlFor="namaFile" className="col-sm-12 col-form-label">
          Nama Dokumen
        </label>
        <div className="col-12">
          <input
            type="text"
            onChange={(e) => setnamaFile(e.target.value)}
            className="form-control"
            id="namaFile"
          />
        </div>
      </div>
      <div className="mb-3 row">
        <label htmlFor="deskripsi" className="col-sm-12 col-form-label">
          Deskripsi
        </label>
        <div className="col-12">
          <textarea
            className="form-control"
            id="deskripsi"
            onChange={(e) => setDeskripsi(e.target.value)}
            value={deskripsi}
            rows={3}
          ></textarea>
        </div>
      </div>
      <div className="mb-3 row">
        <label className="col-sm-12 col-form-label">
          Elemen Penilaian Terkait
        </label>
        <div className="col-12">
          <SelectInstruments
            onChange={setScoreIds}
            options={scores.filter((s) => s.value !== props?.score?.id)}
            filterOption={filterEpOption}
            placeholder="Cari.."
            isMulti={true}
          />
          <small className="text-info">Pilih Elemen Penilaian lain yang terkait dengan dokumen ini (jika ada).</small>
        </div>
      </div>

      <div className="mt-5 row">
        <div className="col-12">
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            Tutup
          </Button>
          &nbsp;
          <Button
            disabled={disabled}
            variant="success"
            size="sm"
            onClick={() => handleSubmitDocumentSupport()}
          >
            {loading === true ? "Mohon Tunggu.." : "Simpan"}
          </Button>
        </div>
      </div>
    </>
  );
};

export default AddDocumentSupportComp;
